// copy URL button
const copyURLButtons = document.querySelectorAll('[data-copy-url]');

copyURLButtons.forEach((button) => {
  button.addEventListener('click', (event) => {
    event.preventDefault();

    const inputCopy = document.body.appendChild(document.createElement('input'));
    inputCopy.value = window.location.href;
    inputCopy.focus();
    inputCopy.select();
    document.execCommand('copy');
    inputCopy.parentNode.removeChild(inputCopy);
    alert('URL copied to the clipboard');
  });
});

// responsive video
const embededVideo = document.querySelectorAll('iframe[src*="youtube"]');

embededVideo.forEach((video) => {
  const holder = video.parentElement;
  const oldHtml = holder.innerHTML;
  const newHtml = `<div class="videoWrapper">${oldHtml}</div>`;

  holder.innerHTML = newHtml;
});
